import { LogLevel } from '@nts/std/src/lib/utility';

export const environment = {
  production: true,
  baseAppUrl: 'https://ntsglobalreportmanager.ntsinformatica.it',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'GlobalReportManager - DEV',
  appSubTitle: '',
  isEnterpriseBarrierRequired: false,
  logLevel: LogLevel.All,
};
